import React, { Component } from 'react'
import sampleSize from 'lodash/sampleSize'
import shuffle from 'lodash/shuffle'
import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker'
import findIndex from 'lodash/findIndex'
import Select from 'react-select'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-select/dist/react-select.css'
import inRange from 'lodash/inRange'
import groupBy from 'lodash/groupBy'
import sortBy from 'lodash/sortBy'
import filter from 'lodash/filter'
import orderBy from 'lodash/orderBy'
import moment from 'moment'
import Checkbox from 'rc-checkbox'
import UserIcon3 from '../../assets/user-image-plc/User_Icon_3.svg'
import { BsArrowDownRightSquare, BsPerson } from 'react-icons/bs'
import {
  BiDownArrowAlt,
  BiUserCircle,
  BiFilter,
  BiLink,
  BiPlus,
  BiRun,
  BiSort,
  BiHide,
  BiTask,
  BiTrash,
  BiUnlink,
  BiUpArrowAlt,
  BiX,
  BiXCircle,
} from 'react-icons/bi'
import {
  LayoutRow,
  ActionLayoutHeading,
  ActionLayoutData,
} from './TableLayoutComponents'
import './ActionsTable.css'
import { CSVLink } from 'react-csv'
import {
  FormGroup,
  Popover,
  Badge,
  Table,
  Progress,
  Modal,
  ModalBody,
  Button,
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  PopoverBody,
  Collapse,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import { connect } from 'react-redux'
import 'rc-checkbox/assets/index.css'
import difference from 'lodash/difference'
import axios from '../../axios'
import * as url from '../../utils/url'
import * as actionCreators from '../../modules/actions/index'
import { capitalizeFirstLetter } from '../../utils/stringUtils'
import PlaceholderWins from './PlaceholderWins'
import {
  task_priority,
  constructGroupLinkedUsersText,
  checkValidityForAnonymousToggleCreate,
  profilePicValidityCheck,
} from '../../utils/constants'
import {
  weeklyWinsInspirations,
  staticTitles,
  taskValidation,
  isUserRemoved,
  placeholder_text,
  whiteLabelStyling,
  action_table_columns,
  action_table_columns_width,
  action_table_columns_min,
  action_table_column_name_display,
} from '../../utils/constants'
import Loading from '../../hoc/Loading/Loading'
import analytics from '../../assets/onboarding/analytics.png'
import isEmpty from 'lodash/isEmpty'
import rocket from '../../assets/onboarding/rocket.png'
import toolkit from '../../assets/onboarding/toolkit.png'
import ww from '../../assets/onboarding/ww.png'
import stories from '../../assets/onboarding/Stories.png'
import welcome from '../../assets/onboarding/welcome.png'
import Toggle from 'react-toggle'
import If from '../../components/Shared/If'
import size from 'lodash/size'
import autosize from 'autosize'
import CKEditorUI from '../../components/CKEditor/CKEditorUI'
import ReactTooltip from 'react-tooltip'
import PlaceholderObjectives from '../enterpriseObjective/PlaceholderObjectives'
import PriorityContainer from '../../components/PriorityContainer/PriorityContainer'
import SingleTask from './SingleTask'
import CreateTaskModal from './CreateTaskModal'
import ActionRow, { ActionTitle } from './ActionRow'
import { isMobile } from '../../utils/deviceInfo'
import ActionsFilterComponent from './ActionsFilterComponent'
import BottomScrollListener from 'react-bottom-scroll-listener'
import { forEach } from 'lodash'
import { deepClone } from '../../utils/copyObject'

class ActionsTable extends Component {
  constructor(props) {
    super(props)

    const hideAnonymous =
      props.user.profile && props.user.profile.organizationId.disableAnonymity
        ? checkValidityForAnonymousToggleCreate(
            'planning',
            props.user.profile.organizationId.disableAnonymity
          )
        : false

    let { user, table_params } = this.props,
      table_type
    if (table_params && table_params.type) {
      let { type, selected } = table_params
      if (type == 'planning') {
        table_type = selected
      }
    }

    let user_columns =
      user &&
      user.profile &&
      user.profile.table_layout &&
      user.profile.table_layout.planning_module &&
      user.profile.table_layout.planning_module[table_type]
        ? user.profile.table_layout.planning_module[table_type].headers
        : []

    console.log('user_columns ---- ', user_columns)

    if (props.showTypeColumn) {
      if (!user_columns.find((x) => x.name == 'type')) {
        user_columns.push({
          name: 'type',
          position: user_columns.length,
        })
      }
    } else {
      user_columns = user_columns.filter((x) => x.name != 'type')
    }

    const getColsToShow = () => {
      if (user_columns.length > 0) {
        return user_columns.map((e) => e.name)
      } else {
        return action_table_columns_min
      }
    }

    this.state = {
      allTodos: [],
      allTodosCopy: [],
      actionColumnShown: getColsToShow(),
      favoriteChartCount: 0,
      favoriteToolCount: 0,
      objectivePopoverOpen: false,
      enterpiseObjective: false,
      privacy: 'PRIVATE',
      isRemoved: false,
      isAnonymousVisible: !hideAnonymous,
      inspirations: [],
      dateError: false,

      showToolDesc: [],

      parentTaskDateAdded: false,
      isHover: false,

      description: {
        value: '',
        error: false,
      },
      dropdownOpen: false,
      dropdownOpenCol: '',
      toolID: '',
      permissionPopoverOpen: false,
      privacyPopoverOpen: false,
      taskType: '',
      showModal: false,
      showActionsLinkModal: false,
      showIntro: !this.props.user.profile.hideIntro,
      removedIntro: "Don't show this again",
      modalActionType: 'Create',
      items: [
        {
          src: welcome,
          altText: 'Slide 1',
          caption: 'Slide 1',
        },
        {
          src: ww,
          altText: 'Slide 2',
          caption: 'Slide 2',
        },
        {
          src: analytics,
          altText: 'Slide 3',
          caption: 'Slide 3',
        },
        {
          src: toolkit,
          altText: 'Slide 4',
          caption: 'Slide 4',
        },
        {
          src: rocket,
          altText: 'Slide 5',
          caption: 'Slide 5',
        },
      ],
      enterpiseObjectives: [],
      isEnterpiseObjectiveSelected: false,
      objectiveId: '',
      actionId: '',
      inspirationsCount: 5,
      expanded: false,
      selectedFilter: '',
      sortByKey: '',
      sortOrder: '',
      quickActionsCollapseOpen: false,
      editModalId: null,
      showEditModal: false,
      editModalTitle: '',
      modalObjectiveTitle: '',
      editModalObjectiveId: null,
      selectedTask: null,
    }
    this.timer = null

    this.weeklyWinsInput = null
  }

  sortTaskStatus = (task) => {
    if (!task.dueDate && !task.completedDate) {
      return 'On-going'
    }
    if (this.isDueDatePast(task)) {
      return 'Overdue'
    }

    if (task.completedDate) {
      if (
        moment(task.completedDate).format('YYYY-MM-DD') <=
          moment(task.dueDate).format('YYYY-MM-DD') ||
        moment(task.completedDate).format('YYYY-MM-DD') >
          moment(task.dueDate).format('YYYY-MM-DD')
      ) {
        return 'Complete'
      }
    }

    if (
      task.dueDate &&
      moment(task.dueDate).format('YYYY-MM-DD') >=
        moment().format('YYYY-MM-DD') &&
      !task.completedDate
    ) {
      return 'Not Due'
    }
  }

  componentDidMount() {
    const { tableType } = this.props
    const { actionColumnShown } = this.state

    if (tableType === 'subAction') {
      const columns = actionColumnShown.filter((x) => x != 'project')

      this.setState({ actionColumnShown: columns })
    }
    window.scrollTo(0, 0)
    const inspirations = sampleSize(
      weeklyWinsInspirations,
      this.state.inspirationsCount
    )
    window.scrollTo(0, 0)

    this.setState({
      inspirations: inspirations,
    })

    if (this.props.allTasks) {
      this.setState({
        allTodos: [...this.props.allTasks],
        allTodosCopy: [...this.props.allTasks],
      })
    }

    this.getAllActions()
  }

  toggleQuickActionsCollapse = () => {
    this.setState({
      quickActionsCollapseOpen: !this.state.quickActionsCollapseOpen,
    })
  }

  assignedUserFormat = (selectedUser) => {
    // console.log(selectedUser)
    let obj = {
      fullName: `${selectedUser.firstName} ${selectedUser.lastName}`,
      user: selectedUser,
    }
    this.setState({ assignedUser: obj, users: [] })
    return obj
  }

  /**
   * load more/less Inpirations
   */
  loadMoreInpirations = () => {
    const count = this.state.expanded === true ? 5 : 10
    const inspirations = sampleSize(shuffle(weeklyWinsInspirations), count)
    this.setState((currentState) => ({
      inspirations: inspirations,
      inspirationsCount: count,
      expanded: !currentState.expanded,
    }))
  }

  /**
   * refresh Inpiraions list
   */

  refreshInpirations = () => {
    const inspirations = sampleSize(
      shuffle(weeklyWinsInspirations),
      this.state.inspirationsCount
    )
    this.setState({
      inspirations: inspirations,
    })
  }

  toggleCol = (col) => {
    let { dropdownOpenCol } = this.state
    // console.log(dropdownOpenCol,'col----', col)
    if (dropdownOpenCol === col) {
      this.setState({ dropdownOpenCol: '' })
    } else {
      this.setState({ dropdownOpenCol: col })
    }
  }

  setEditTitle = (title) => {
    // console.log(title)
    return title
  }

  componentWillReceiveProps(nextProps) {
    console.log(
      'facttttt',
      nextProps.allTasks.length,
      this.props.allTasks.length
    )
    if (
      JSON.stringify(nextProps.allTasks) !== JSON.stringify(this.props.allTasks)
    ) {
      console.log('chnggggg')
      this.setState({
        allTodos: [...nextProps.allTasks],
        allTodosCopy: [...nextProps.allTasks],
      })
      // this.handleSortChange(
      //   this.props.sortParams.sortBy,
      //   this.props.sortParams.sortOrder
      // );

      setTimeout(() => {
        const { sortParams, filterParams } = this.props
        if (sortParams.sortBy && sortParams.sortOrder) {
          this.handleSortChange(sortParams.sortBy, sortParams.sortOrder)
        }
      }, 500)
    }

    if (
      JSON.stringify(this.props.sortParams) !==
      JSON.stringify(nextProps.sortParams)
    ) {
      this.handleSortChange(
        nextProps.sortParams.sortBy,
        nextProps.sortParams.sortOrder
      )
    }

    if (
      JSON.stringify(this.props.filterParams) !==
      JSON.stringify(nextProps.filterParams)
    ) {
      this.handleFilterChange(nextProps.filterParams)
    }
  }

  togglePrivacySettings = () => {
    this.setState({
      privacyPopoverOpen: !this.state.privacyPopoverOpen,
      permissionPopoverOpen: false,
    })
  }

  toggleObjectiveSettings = () => {
    this.setState({
      objectivePopoverOpen: !this.state.objectivePopoverOpen,
    })
  }

  togglePersmission = () => {
    this.setState({
      permissionPopoverOpen: !this.state.permissionPopoverOpen,
      privacyPopoverOpen: false,
    })
  }

  toggleActionsLink = (todo) => {
    const actionType = !isEmpty(todo.parentTask) ? 'unlink' : 'link'
    actionType == 'link' ? this.getEOList(todo) : this.unlinkEO(todo)
  }

  getEOList = (todo) => {
    // console.log('get objectives')
    axios
      .get(`${url.getEnterpriseObjectives}/${todo.organizationId}`, {
        params: {
          removeDeleted: true,
        },
      })
      .then(({ data }) => {
        this.setState({
          enterpiseObjectives: data.data.taskList,
          showActionsLinkModal: !this.state.showActionsLinkModal,
          actionId: todo._id,
        })
      })
  }

  unlinkEO = (todo) => {
    let reqObject = {
      objectiveId: todo.parentTask.item,
      actionId: todo._id,
    }
    //url.unlinkEnterpriseObjectiveAction
    axios
      .post(url.unlinkEnterpriseObjectiveAction, reqObject)
      .then(({ data }) => {
        this.setState({
          objectiveId: '',
        })
        this.getAllActions()
      })
  }

  handleRowClick = (todo) => {
    axios.put(url.markComplete(todo._id)).then(({ data }) => {
      this.getAllActions()
    })
  }

  markIncomplete = (todo) => {
    axios.put(url.markIncomplete(todo._id)).then(({ data }) => {
      this.getAllActions()
    })
  }

  handleDeleteTodo = (todo) => {
    const { allTodos } = this.state

    const allArr = [...allTodos]
    // let { pendingTodos, archivedTodos } = this.state;
    // let i = findIndex(pendingTodos, { _id: todo._id });
    // let selectedTodo = pendingTodos[i];
    // pendingTodos.splice(i, 1);
    // archivedTodos.push(selectedTodo);
    axios.put(url.deleteTodo(todo._id)).then((data) => {
      const todoIndex = allArr.findIndex((x) => x._id == todo._id)
      if (todoIndex >= 0) {
        allArr.splice(todoIndex, 1)
        if (this.props.setAllTasks) {
          this.props.setAllTasks(allArr)
        }
      }
    })
  }

  handleUnDeleteTodo = (todo) => {
    const { allTodos } = this.state

    const allArr = [...allTodos]
    axios.put(url.undeleteTodo(todo._id)).then((data) => {
      const todoIndex = allArr.findIndex((x) => x._id == todo._id)
      if (todoIndex >= 0) {
        allArr.splice(todoIndex, 1)
        if (this.props.setAllTasks) {
          this.props.setAllTasks(allArr)
        }
      }
    })
  }

  viewEditTask = (item) => {
    // this.props.history.push(`/home/planning/${item._id}`);
    const { tableType } = this.props
    if (tableType === 'subAction') {
      this.props.chainingEditHandler(item, true)
    } else {
      this.setState({
        editModalId: item._id,
        showEditModal: true,
        selectedTask: item,
      })
    }
  }

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : 'N'
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : 'N'
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
  }

  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div> ${input} </div>` }
  }

  assignedUserCheck = (task) => {
    // console.log('task---', task)

    if (
      task &&
      task.assignedTo &&
      (task.assignedTo.firstName || task.assignedTo._id)
    ) {
      let assignedUser =
        task.assignedTo && task.assignedTo.firstName
          ? task.assignedTo
          : task.assignedToDoc
          ? task.assignedToDoc
          : false

      let assignedUserFullName = assignedUser.lastName
        ? assignedUser.firstName + ' ' + assignedUser.lastName
        : assignedUser.firstName
        ? assignedUser.firstName
        : ''
      let { profile } = this.props.user
      let taskOwner = isUserRemoved(task.userId)
        ? 'Inactive User'
        : task.userId._id.toString() == profile._id.toString()
        ? profile
        : task.userId

      assignedUserFullName = isUserRemoved(task.assignedTo)
        ? 'Inactive User'
        : assignedUserFullName
      return (
        <div className="" data-tip={assignedUserFullName}>
          {profilePicValidityCheck(assignedUser.profilePic) ? (
            <img
              src={assignedUser.profilePic || UserIcon3}
              height="26px"
              width="26px"
              style={{ borderRadius: '50%', objectFit: 'cover' }}
            />
          ) : (
            <span
              className="spotlightUserInitials"
              id="spotlightUserInitials"
              style={{ width: '30px' }}
              data-for={'spotlightUserInitials'}
              data-letters={this.getInitials(assignedUser)}
            />
          )}
          <ReactTooltip id="spotlightUserInitials" />
        </div>
      )
    } else {
      return <BsPerson size={'25px'} className="actionsNoAssignee" />
    }
  }

  populateTodos = (todos) => {
    todos = orderBy(
      todos,
      [
        ({ dueDate }) =>
          dueDate &&
          moment(dueDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')
            ? dueDate
            : dueDate && moment().diff(dueDate, 'days') == 0
            ? dueDate
            : dueDate && moment().diff(dueDate, 'days') > 0
            ? dueDate
            : dueDate == undefined || dueDate == null
            ? null
            : dueDate,
        'lastUpdate',
        'createdOn',
      ],
      ['asc', 'desc', 'desc']
    )

    return todos
  }

  editTask = (todo) => {
    let { allTodos } = this.state
    let i = findIndex(allTodos, { _id: todo._id })
    let selectedTodo = allTodos[i]
    // console.log(selectedTodo)
    this.setState({ selectedTodoTitle: selectedTodo.title })

    let {
      description,
      title,
      privacy,
      parentTaskDateAdded,
      isAnonymous,
      userId,
    } = selectedTodo
    // description = this.createMarkup(description)
    let eObjective =
      parentTaskDateAdded !== undefined &&
      parentTaskDateAdded !== null &&
      parentTaskDateAdded !== 'undefined'
        ? true
        : false
    let pDate =
      parentTaskDateAdded !== undefined &&
      parentTaskDateAdded !== null &&
      parentTaskDateAdded !== 'undefined'
        ? parentTaskDateAdded
        : false
    let titleCheck =
      title !== undefined && title !== null && title !== 'undefined'
        ? title
        : ''
    let privacyCheck =
      privacy !== undefined && privacy !== null && privacy !== 'undefined'
        ? privacy
        : 'PRIVATE'

    let isAssigned, assignedUser, isDueDate, dueDate

    if (selectedTodo.assignedTo && selectedTodo.assignedTo._id) {
      isAssigned = true
      assignedUser = this.assignedUserFormat(selectedTodo.assignedTo)
    }

    if (selectedTodo.dueDate) {
      isDueDate = true
      dueDate = moment(selectedTodo.dueDate)
    }

    this.setState({
      showModal: true,
      description: { value: description },
      title: { value: title },
      title,
      modalActionType: 'Edit',
      userId,
      privacy: privacyCheck,
      enterpiseObjective: eObjective,
      parentTaskDateAdded: pDate,
      edit: true,
      toolID: selectedTodo._id,
      dropdownOpen: false,
      isAnonymous: isAnonymous,
      isAssigned,
      isDueDate,
      // assignedUser,
      dueDate,
    })
  }

  handleSubmitLinkAction = () => {
    this.setState({
      showActionsLinkModal: false,
    })
    let { objectiveId, actionId, isAnonymous } = this.state
    let reqObject = {
      objectiveId: objectiveId,
      actionId: actionId,
      isAnonymous: isAnonymous,
    }
    axios
      .post(url.linkEnterpriseObjectiveAction, reqObject)
      .then(({ data }) => {
        this.setState({
          objectiveId: '',
          isAnonymous: false,
        })
        this.getAllActions()
      })
  }

  getAllActions = () => {
    this.props.getAllData()
  }
  populateInpirations = () => {
    const { inspirations } = this.state
    return inspirations.map((inspiration, i) => {
      let insp = inspiration
      return (
        <div
          className="weekly-inspiration-row"
          key={i}
          onClick={() => this.copyInspiration(insp)}>
          <i className="weekly-inspiration flaticon-plus mr10"></i>
          <div>{inspiration}</div>
        </div>
      )
    })
  }

  populateEnterpriseObjectives = () => {
    const { enterpiseObjectives, objectiveId } = this.state
    {
      return size(enterpiseObjectives) > 0 ? (
        enterpiseObjectives.map((eo, i) => {
          const isEOLinked = eo._id === objectiveId
          return (
            <Row key={i}>
              <Col>
                <div className="radio ml0 mt0">
                  <input
                    id={eo._id}
                    name="meRadio"
                    onChange={(e) =>
                      this.handleEnterpriseObjectiveChange(eo, e.target.checked)
                    }
                    type="radio"
                    value={isEOLinked}
                    checked={isEOLinked}
                  />
                  <label
                    htmlFor={eo._id}
                    className="radio-label privacy-radio-label privacy-radio-value">
                    <span className="radio-label link_ent_obj_title">
                      {eo.title}
                    </span>
                    <span className="link_ent_obj_date">
                      created on {moment(eo.createdOn).format('MMM D, YYYY')}
                    </span>
                  </label>
                </div>
              </Col>
            </Row>
          )
        })
      ) : (
        <Row>
          <Col>
            <div>
              <PlaceholderObjectives />
            </div>
          </Col>
        </Row>
      )
    }
  }

  copyInspiration = (e) => {
    this.setState({
      showModal: true,
      description: { value: `<p>${e}</p>\n` },
    })
  }

  handleShowWinsModal = () => {
    this.setState({
      showModal: true,
      modalActionType: 'Create',
    })
  }

  closeShareModal = () => {
    this.setState({
      showModal: false,
      description: {
        value: `<p>${placeholder_text.action_create}</p>\n`,
        error: false,
      },
    })
  }
  closeActionsLinkModal = () => {
    this.setState({
      showActionsLinkModal: false,
      isEnterpiseObjectiveSelected: false,
      isAnonymous: false,
      objectiveId: '',
    })
  }

  closeIntroModal = () => {
    this.setState({ showIntro: false })
    if (this.state.isRemoved) {
      this.props.onProfileUpdate({ hideIntro: true })
    }
  }

  componentWillUnmount() {
    if (this.state.isRemoved) {
      this.props.onProfileUpdate({ hideIntro: true })
    }
  }

  handleOptionChange = (changeEvent) => {
    if (changeEvent.target.value !== 'PRIVATE') {
      this.setState({
        privacy: changeEvent.target.value,
        // isAnonymousVisible: false,
      })
    } else {
      this.setState({
        privacy: changeEvent.target.value,
        enterpiseObjective: false,
        // isAnonymousVisible: true,
      })
    }
  }

  handleEnterpriseObjectiveChange = (itemObject, selected) => {
    this.setState({
      isEnterpiseObjectiveSelected: selected,
      objectiveId: itemObject._id,
    })
  }

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    })
  }

  handleAssignedChange = (changeEvent) => {
    let checkValue = changeEvent.target.checked

    let stateUpdate = {
      isAssigned: changeEvent.target.checked,
    }

    if (!checkValue) {
      stateUpdate.users = []
      stateUpdate.assignedUser = {}
    }

    this.setState(stateUpdate)
  }

  handleObjective = (e) => {
    this.setState({ enterpiseObjective: !this.state.enterpiseObjective })
  }

  handleFilterChange = (filter) => {
    let todos = [...this.state.allTodosCopy]
    const doc = filter.filtersDoc

    if (this.props.onPageFilter) {
      for (const key in doc) {
        if (Object.hasOwnProperty.call(doc, key)) {
          const ele = doc[key]

          if (
            ele &&
            ele !== '' &&
            this.props.searchActions &&
            key === 'title'
          ) {
            todos = todos.filter((itm) =>
              itm.title.toLowerCase().includes(ele.toLowerCase())
            )
          }

          if (key === 'status') {
            if (ele.value === 'OVERDUE') {
              todos = todos.filter((itm) =>
                ele.equalsOrIncludes
                  ? this.isDueDatePast(itm)
                  : !this.isDueDatePast(itm)
              )
            } else {
              todos = todos.filter((itm) =>
                ele.equalsOrIncludes
                  ? !this.isDueDatePast(itm)
                  : this.isDueDatePast(itm)
              )
            }
          } else if (key === 'dueDate') {
            if (Array.isArray(ele.value)) {
              const start = moment(ele.value[0])
              const end = moment(ele.value[1])

              if (start && end) {
                todos = todos.filter((itm) =>
                  ele.equalsOrIncludes
                    ? moment(itm.dueDate).isBetween(start, end)
                    : !moment(itm.dueDate).isBetween(start, end)
                )
              }
            } else {
              todos = todos.filter((itm) =>
                ele.equalsOrIncludes
                  ? moment(itm.dueDate).format('YYYY-MM-DD') ==
                    moment(ele.value).format('YYYY-MM-DD')
                  : moment(itm.dueDate).format('YYYY-MM-DD') !=
                    moment(ele.value).format('YYYY-MM-DD')
              )

              console.log(todos)
            }
          } else if (key === 'completedDate') {
            if (Array.isArray(ele.value)) {
              const start = moment(ele.value[0])
              const end = moment(ele.value[1])

              if (start && end) {
                todos = todos.filter((itm) =>
                  ele.equalsOrIncludes
                    ? moment(itm.completedDate).isBetween(start, end)
                    : !moment(itm.completedDate).isBetween(start, end)
                )
              }
            } else {
              todos = todos.filter((itm) =>
                ele.equalsOrIncludes
                  ? moment(itm.completedDate).format('YYYY-MM-DD') ==
                    moment(ele.value).format('YYYY-MM-DD')
                  : moment(itm.completedDate).format('YYYY-MM-DD') !=
                    moment(ele.value).format('YYYY-MM-DD')
              )
            }
          } else if (key === 'createdDate') {
            if (Array.isArray(ele.value)) {
              const start = moment(ele.value[0])
              const end = moment(ele.value[1])

              if (start && end) {
                todos = todos.filter((itm) =>
                  ele.equalsOrIncludes
                    ? moment(itm.createdOn).isBetween(start, end)
                    : !moment(itm.createdOn).isBetween(start, end)
                )
              }
            } else {
              todos = todos.filter((itm) =>
                ele.equalsOrIncludes
                  ? moment(itm.createdOn).format('YYYY-MM-DD') ==
                    moment(ele.value).format('YYYY-MM-DD')
                  : moment(itm.createdOn).format('YYYY-MM-DD') !=
                    moment(ele.value).format('YYYY-MM-DD')
              )
            }
          } else if (key === 'assignee') {
            todos = todos.filter((itm) =>
              ele.equalsOrIncludes
                ? itm.assignedTo && itm.assignedTo._id === ele.value._id
                : itm.assignedTo && itm.assignedTo._id !== ele.value._id
            )
          } else if (key === 'progress') {
            if (ele.equalsOrIncludes) {
              if (ele.value === 'IN_PROGRESS') {
                todos = todos.filter(
                  (itm) =>
                    !itm.completedDate && this.checkProgressBarValue(itm) > 0
                )
              } else if (ele.value === 'NOT_STARTED') {
                todos = todos.filter(
                  (itm) =>
                    !itm.completedDate && this.checkProgressBarValue(itm) === 0
                )
              } else if (ele.value === 'COMPLETED') {
                todos = todos.filter((itm) => itm.completedDate)
              }
            } else {
              if (ele.value === 'IN_PROGRESS') {
                todos = todos.filter(
                  (itm) =>
                    (!itm.completedDate &&
                      this.checkProgressBarValue(itm) === 0) ||
                    itm.completedDate
                )
              } else if (ele.value === 'NOT_STARTED') {
                todos = todos.filter(
                  (itm) =>
                    (!itm.completedDate &&
                      this.checkProgressBarValue(itm) > 0) ||
                    itm.completedDate
                )
              } else if (ele.value === 'COMPLETED') {
                todos = todos.filter(
                  (itm) =>
                    (!itm.completedDate &&
                      this.checkProgressBarValue(itm) > 0) ||
                    this.checkProgressBarValue(itm) === 0
                )
              }
            }
          } else if (key === 'priority') {
            todos = todos.filter((itm) =>
              ele.equalsOrIncludes
                ? itm.priority >= 0 && itm.priority == ele.value
                : itm.priority >= 0 && itm.priority != ele.value
            )
          } else if (key === 'linkedActions') {
            todos = todos.filter((itm) =>
              ele.equalsOrIncludes
                ? itm.taskCounter == ele.value
                : itm.taskCounter != ele.value
            )
          } else if (key === 'createdBy') {
            todos = todos.filter((itm) =>
              ele.equalsOrIncludes
                ? itm.userId && itm.userId._id === ele.value._id
                : itm.userId && itm.userId._id !== ele.value._id
            )
          } else if (key === 'privacyStatus') {
            todos = todos.filter((itm) => {
              if (ele.equalsOrIncludes) {
                if (ele.value === 'ASSIGNED_ME') {
                  todos = todos.filter(
                    (itm) =>
                      itm.userId &&
                      itm.userId._id !== this.props.user.profile._id &&
                      itm.privacy === 'PRIVATE'
                  )
                } else {
                  todos = todos.filter((itm) => itm.privacy === ele.value)
                }
              } else {
                if (ele.value === 'ASSIGNED_ME') {
                  todos = todos.filter(
                    (itm) =>
                      itm.userId &&
                      itm.userId._id !== this.props.user.profile._id
                  )
                } else {
                  todos = todos.filter((itm) => itm.privacy !== ele.value)
                }
              }
            })
          }
        }
      }

      this.setState({ allTodos: [...todos] })
    } else {
      if (Object.keys(doc).length > 0) {
        this.props.getAllData('APPLY')
      } else {
        this.props.getAllData('CLEAR')
      }
    }
  }

  isDueDatePast = (todo) => {
    if (
      // todo.isDeleted != true &&
      !todo.completedDate &&
      todo.dueDate &&
      todo.dueDate != null &&
      todo.dueDate != undefined &&
      moment(todo.dueDate).format('YYYY-MM-DD') < moment().format('YYYY-MM-DD')
    ) {
      return true
    }
    return false
  }

  handleSortChange = (key, order) => {
    let todos = [...this.state.allTodos]
    console.log(key)
    switch (key) {
      case 'assignee':
        let valid = todos.filter((itm) => itm.assignedTo)
        let rest = todos.filter((itm) => !itm.assignedTo)
        valid = orderBy(
          valid,
          (itm) => {
            const name = `${itm.assignedTo.firstName || ''} ${itm.assignedTo
              .lastName || ''}`
            return name
          },
          [order]
        )
        todos = [...valid, ...rest]
        break
      case 'project':
        let validTask = todos.filter(
          (itm) => itm.parentTask && itm.parentTaskTitle
        )
        let restTask = todos.filter((itm) => !itm.parentTaskTitle)
        validTask = orderBy(
          validTask,
          (itm) => itm.parentTaskTitle.toLowerCase(),
          [order]
        )
        todos = [...validTask, ...restTask]
        break

      case 'dueDate':
        let validDates = todos.map((itm) => ({
          ...itm,
        }))
        validDates = orderBy(
          validDates,
          (itm) => moment(itm[key] || new Date(8640000000000000)),
          [order]
        )

        todos = [...validDates]

        break

      case 'progress':
        todos = orderBy(todos, (itm) => this.checkProgressBarValue(itm), [
          order,
        ])
        break

      case 'priority':
        let validPriority = todos.filter((itm) => itm.priority)
        let restPriority = todos.filter((itm) => !itm.priority)
        validPriority = orderBy(validPriority, (itm) => itm.priority, [order])
        todos = [...validPriority, ...restPriority]
        break
      case 'actionTitle':
        todos = orderBy(todos, (itm) => itm['title'].toLowerCase(), [order])
        break

      case 'status':
        todos = orderBy(todos, (itm) => this.sortTaskStatus(itm), [order])

        break

      case 'privacyStatus':
        const publics = todos.filter(
          (itm) => itm.privacy == null || itm.privacy == 1
        )
        const privates = todos.filter((itm) => itm.privacy == 0)
        if (order === 'asc') {
          todos = [...publics, ...privates]
        } else {
          todos = [...privates, ...publics]
        }
        break

      case 'createdBy':
        let validCreated = todos.filter((itm) => itm.userId)
        let restCreated = todos.filter(
          (itm) => !itm.userId || itm.userId.isDeleted
        )
        validCreated = orderBy(
          validCreated,
          (itm) => {
            const name = `${itm.userId.firstName || ''} ${itm.userId.lastName ||
              ''}`
            return name
          },
          [order]
        )
        todos = [...validCreated, ...restCreated]
        break

      default:
        todos = orderBy(todos, (itm) => itm[key], [order])
        console.log(todos)
        break
    }
    console.log(todos.map((x) => x.title))
    this.setState({ allTodos: [...todos] })
  }

  changeSortField = (key, order) => {
    this.props.updateSortParams({
      sortBy: key,
      sortOrder: order,
    })
  }

  sortComponent = (key) => {
    const { sortParams } = this.props
    // console.log('key --- ', key)
    if (
      JSON.stringify(sortParams.sortBy) === JSON.stringify(key) &&
      sortParams.sortOrder === 'asc'
    ) {
      return (
        <BiDownArrowAlt
          size={'18px'}
          // onClick={() => this.changeSortField(key, "desc")}
        />
      )
    } else {
      return (
        <BiUpArrowAlt
          size={'18px'}
          // onClick={() => this.changeSortField(key, "asc")}
        />
      )
    }
  }

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      editModalId: null,
      selectedTask: null,
    })
  }

  handleUpdateInTable = (task) => {
    const allOrgIndex = this.state.allTodos.findIndex(
      (itm) => itm._id === task._id
    )

    const removeTask = (id, array, copy) => {
      const deleteIndex = array.findIndex((itm) => itm._id === id)
      const allTodoArr = [...array]

      allTodoArr.splice(deleteIndex, 1)

      if (!copy) {
        this.setState({ allTodos: allTodoArr })
      } else {
        this.setState({ allTodosCopy: allTodoArr })
      }
    }

    if (
      this.props.showPublicActions ||
      this.props.isArchived ||
      this.props.showMyActions
    ) {
      if (task.operation === 'ARCHIVE') {
        removeTask(task._id, [...this.state.allTodos], false)
        return
      }
      if (task.operation === 'UNARCHIVE') {
        removeTask(task._id, [...this.state.allTodos], false)
        return
      }
    }

    if (allOrgIndex > -1) {
      if (!this.props.isObjectiveDetailsPage) {
        const allTodoArr = [...this.state.allTodos]
        allTodoArr[allOrgIndex] = { ...allTodoArr[allOrgIndex], ...task }
        this.setState({ allTodos: allTodoArr })
      } else {
        //write obj detail page related logic here
        const allTodoArr = [...this.state.allTodos]
        if (task.parentTask) {
          if (task.parentTask.item) {
            let newId = task.parentTask.item
            if (typeof newId == 'string') {
              if (newId === this.props.enterpiseObjectiveId) {
                const allTodoArr = [...this.state.allTodos]
                allTodoArr[allOrgIndex] = {
                  ...allTodoArr[allOrgIndex],
                  ...task,
                }
                this.setState({ allTodos: allTodoArr })
              } else {
                removeTask(task._id, allTodoArr, false)
              }
            } else {
              const allTodoArr = [...this.state.allTodos]
              allTodoArr[allOrgIndex] = { ...allTodoArr[allOrgIndex], ...task }
              this.setState({ allTodos: allTodoArr })
            }
          } else {
            removeTask(task._id, allTodoArr, false)
          }
        } else {
          removeTask(task._id, allTodoArr, false)
        }
      }
    }

    const allOrgCopyIndex = this.state.allTodosCopy.findIndex(
      (itm) => itm._id === task._id
    )
    if (allOrgCopyIndex > -1) {
      if (!this.props.isObjectiveDetailsPage) {
        const allTodoArr = [...this.state.allTodosCopy]
        allTodoArr[allOrgCopyIndex] = {
          ...allTodoArr[allOrgCopyIndex],
          ...task,
        }
        this.setState({ allTodosCopy: allTodoArr })
      } else {
        //write obj detail page related logic here
        const allTodoArr = [...this.state.allTodosCopy]
        if (task.parentTask) {
          if (task.parentTask.item) {
            let newId = task.parentTask.item
            if (typeof newId == 'string') {
              if (newId === this.props.enterpiseObjectiveId) {
                const allTodoArr = [...this.state.allTodosCopy]
                allTodoArr[allOrgCopyIndex] = {
                  ...allTodoArr[allOrgCopyIndex],
                  ...task,
                }
                this.setState({ allTodosCopy: allTodoArr })
              } else {
                removeTask(task._id, allTodoArr, true)
              }
            } else {
              const allTodoArr = [...this.state.allTodosCopy]
              allTodoArr[allOrgCopyIndex] = {
                ...allTodoArr[allOrgCopyIndex],
                ...task,
              }
              this.setState({ allTodosCopy: allTodoArr })
            }
          } else {
            removeTask(task._id, allTodoArr, true)
          }
        } else {
          removeTask(task._id, allTodoArr, true)
        }
      }
    }
  }

  handlePriorityChange = (task) => {
    axios
      .post(url.editTodo, {
        taskUpdate: { ...task },
        updatedFields: ['priority'],
      })
      .then(({ data }) => {
        const newTask = data.data
        this.handleUpdateInTable(newTask)
      })
      .catch((err) => console.log(err))
  }

  onAddSuccess = (data) => {
    this.state.allTodos.unshift(data)
    this.state.allTodosCopy.unshift(data)
    this.closeShareModal()
    if (this.props.onSubActionAdd) {
      this.props.onSubActionAdd()
    }
  }

  checkProgressBarValue = (task) => {
    let res
    if (
      task.percentComplete &&
      task.percentComplete.length > 0 &&
      task.percentComplete[0].value
    ) {
      res = task.percentComplete[0].value
    } else if (
      task.incompleteDate &&
      new Date(task.incompleteDate).valueOf() != NaN
    ) {
      res = 0
    } else if (
      task.completedDate &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      res = 100
    } else if (
      task.incompleteDate &&
      task.completedDate &&
      new Date(task.incompleteDate).valueOf() != NaN &&
      new Date(task.completedDate).valueOf() != NaN
    ) {
      if (task.completedDate > task.incompleteDate) {
        res = 100
      } else {
        res = 0
      }
    } else {
      res = 0
    }
    return res
  }

  renderDDtab = (col) => {
    const { sortParams, plainTable } = this.props
    let { dropdownOpenCol } = this.state
    let colName = col.toUpperCase()
    let sortOrder = 'asc'
    if (col == 'dueDate') {
      colName = 'Due date'
    } else if (col == 'project') {
      colName = 'Objective'
    } else if (col == 'actionTitle') {
      colName = 'Title'
    } else if (col == 'privacyStatus') {
      colName = 'Privacy'
    }

    if (col == 'taskCounter') {
      colName = 'Sub Actions'
    }

    if (
      JSON.stringify(sortParams.sortBy) === JSON.stringify(col) &&
      sortParams.sortOrder === 'asc'
    ) {
      sortOrder = 'desc'
    } else {
      sortOrder = 'asc'
    }

    if (col != 'actionTitle') {
      return (
        <Dropdown
          isOpen={dropdownOpenCol == colName}
          toggle={() => this.toggleCol(colName)}>
          <DropdownToggle
            caret
            size="lg"
            tag={plainTable && 'span'}
            className="action-table-col-overlap">
            {colName}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => this.changeSortField(col, sortOrder)}>
              {this.sortComponent(col)} Sort
            </DropdownItem>
            <DropdownItem onClick={() => this.hideColumn(col)}>
              <BiHide size={'22px'} /> Hide column{' '}
            </DropdownItem>
            {/* <DropdownItem onClick={()=> this.changeColPosition(col)}><BiHide size={"22px"}/> Change position </DropdownItem> */}
          </DropdownMenu>
        </Dropdown>
      )
    } else {
      return (
        <span
          className="action-title-mob"
          onClick={() => this.changeSortField('actionTitle', sortOrder)}>
          {colName} {this.sortComponent(col)}
        </span>
      )
    }
  }

  handleColWidth = (col, mobile) => {
    let m_val = mobile ? 'm' : 'nm'
    let { actionColumnShown } = this.state
    // return  action_table_columns_width[col][m_val]
    return action_table_columns_width(actionColumnShown, col, m_val)
  }

  addColumnToTable = (addCol) => {
    let { actionColumnShown } = this.state
    actionColumnShown = [...actionColumnShown, addCol]
    this.setState({ actionColumnShown })
    this.actionsColAPI(actionColumnShown)
  }

  hideColumn = (col) => {
    let { actionColumnShown } = this.state
    let res = actionColumnShown.filter((e) => e != col)
    this.setState({ actionColumnShown: res })
    this.actionsColAPI(res)
  }

  actionsColAPI = (u_columns) => {
    let included_columns = u_columns.map((e, idx) => {
      return { name: e, position: idx }
    })
    // `table_layout.planning_module.my_actions.headers.${col}` = ''
    // table_type
    let payload = {
        headers: included_columns,
        table_type: this.props.table_type,
      },
      that = this

    axios
      .post(url.changeTableLayout, payload)
      .then(({ data }) => {
        that.props.onProfileUpdate({ table_layout: data.data.table_layout })
      })
      .catch((err) => console.log(err))
  }

  handleAddColumnDD = (colName) => {
    let { dropdownOpenCol } = this.state
    if (dropdownOpenCol != 'addCol') {
      this.setState({ dropdownOpenCol: colName })
    } else {
      this.setState({ dropdownOpenCol: '' })
    }
  }

  getData = (actions) => {
    const actionsToExport = actions.map((itm) => ({
      name: itm.title,
      assignee: itm.assignedTo
        ? `${itm.assignedTo.firstName} ${itm.assignedTo.lastName}`
        : itm.assignedToDoc
        ? `${itm.assignedToDoc.firstName} ${itm.assignedToDoc.lastName}`
        : 'No assignee',
      dueDate: moment(itm.dueDate).format('MMM D, YYYY'),
      progress:
        this.checkProgressBarValue(itm) === 0
          ? 'Not started'
          : inRange(this.checkProgressBarValue(itm), 0, 99.99)
          ? this.checkProgressBarValue(itm) + ' % '
          : 'Complete',
      objective: itm.parentTaskTitle
        ? itm.parentTaskTitle
        : itm.parentTask
        ? itm.parentTask.item.title
        : 'No objective',
      priority: task_priority(itm.priority),
      taskCounter: itm.taskCounter,
    }))

    return actionsToExport
  }

  handleSearchQueryChanged = (e) => {
    const val = e.target.value
    const filterObj = { ...this.props.filterParams.filterDoc }
    if (val) {
      filterObj.title = val
    } else {
      if (filterObj.hasOwnProperty('title')) {
        delete filterObj.title
      }
    }

    this.props.updateFilterParams({
      filtersDoc: filterObj,
    })
  }

  getTableDisplay = () => {
    let { showModal } = this.state
    let { tableType } = this.props

    if (tableType === 'subAction' && showModal) {
      return 'none'
    } else {
      return 'block'
    }
  }

  handleSubActionUnlink = (type, actionId, parentActionId) => {
    axios
      .post(url.unlinkSubAction, {
        actionType: 'subAction',
        actionId: actionId,
        parentActionId: parentActionId,
      })
      .then(({ data }) => {
        if (this.props.onSubActionRemove) {
          this.props.onSubActionRemove()
        }
        const removeTask = (id, array, copy) => {
          const deleteIndex = array.findIndex((itm) => itm._id === id)
          const allTodoArr = [...array]

          allTodoArr.splice(deleteIndex, 1)

          if (!copy) {
            this.setState({ allTodos: allTodoArr })
          } else {
            this.setState({ allTodosCopy: allTodoArr })
          }
        }

        removeTask(actionId, [...this.state.allTodos], false)
        removeTask(actionId, [...this.state.allTodosCopy], true)
      })
      .catch((err) => console.log(err))
  }

  isAssignee = (task) => {
    const { profile } = this.props.user
    if (task && task.assignedTo && task.assignedTo._id) {
      if (profile._id === task.assignedTo._id) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  isCreator = (task) => {
    const { profile } = this.props.user
    if (task && task.userId && task.userId._id) {
      if (profile._id === task.userId._id) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  handleOnDocumentBottom = () => {
    if (this.props.handleOnScrollPaginate) {
      this.props.handleOnScrollPaginate()
    }
  }

  getTotalColsCounter = (cols) => {
    let count = 0

    cols.forEach((x) => {
      let m_val = isMobile ? 'm' : 'nm'
      count += action_table_columns_width(cols, x, m_val)
    })

    return count
  }

  render() {
    let {
      isAnonymous,
      enterpiseObjectives,
      description,
      allTodos,
      actionColumnShown,
      dropdownOpenCol,
      allTodosCopy,
    } = this.state

    let currentUser = this.props.user.profile

    let extra_col = difference(action_table_columns, actionColumnShown)

    const totalColsCounter = this.getTotalColsCounter(actionColumnShown)

    //const totalColsCounter = actionColumnShown.length;

    console.log('actionColumnShown', actionColumnShown)

    const {
      sortParams,
      filterParams,
      plainTable,
      exportActions,
      searchActions,
      parentActionId,
      tableType,
      isParentTaskPublic,
      parentActionPrivacy,
    } = this.props

    if (tableType === 'subAction') {
      extra_col = extra_col.filter((x) => x != 'project')
    }

    const { orgAdmin } = this.props.user.profile

    const actionsStaticHeaders = [
      { label: 'Title', key: 'name' },
      { label: 'Assignee', key: 'assignee' },
      { label: 'Progress', key: 'progress' },
      { label: 'Linked Objective', key: 'objective' },
      { label: 'Due Date', key: 'dueDate' },
      { label: 'Priority', key: 'priority' },
      { label: 'Sub Actions', key: 'taskCounter' },
    ]

    return (
      <div className="">
        {this.state.showModal && (
          <CreateTaskModal
            {...this.props}
            open={this.state.showModal}
            onClose={this.closeShareModal}
            onAddSuccess={this.onAddSuccess}
            description={description}
            parentActionId={parentActionId}
            parentActionPrivacy={parentActionPrivacy}
            parentActionTitle={this.props.parentActionTitle}
            tableType={tableType}
          />
        )}

        {this.state.editModalId && this.state.showEditModal ? (
          <Modal
            isOpen={this.state.showEditModal}
            // size="xl"
            className="edit-actions-modal col-lg-9 col-md-9 col-sm-12">
            <SingleTask
              editModalId={this.state.editModalId}
              selectedTask={this.state.selectedTask}
              handleUpdateInTable={this.handleUpdateInTable}
              {...this.props}
              closeEditModal={this.closeEditModal}
              parentActionId={parentActionId}
              tableType={tableType}
              linkedByText={constructGroupLinkedUsersText(
                this.state.selectedTask
              )}
            />
          </Modal>
        ) : (
          ''
        )}

        {/*  Modal for linking enterprise objective  */}

        <Modal
          isOpen={this.state.showActionsLinkModal}
          className="ent-obj-link-modal">
          <ModalBody style={{ padding: '30px' }}>
            <div className="row">
              <If condition={size(enterpiseObjectives) > 0}>
                <div className="weeklyWinTitle pick-office-modal-body-title">
                  Select the Enterprise Objective to link your Action with
                </div>
              </If>
            </div>
            <div className="content-area px-3">
              {this.populateEnterpriseObjectives()}
            </div>

            <If
              condition={
                size(enterpiseObjectives) > 0 && this.state.isAnonymousVisible
              }>
              <div>
                <div className="my-3 pl-0 clearfix">
                  <div className="">
                    <span className="ml10">
                      <Toggle
                        checked={isAnonymous}
                        // icons={false}
                        onChange={this.handlePermissionChange}
                      />
                    </span>
                    <span className="permission-value ml10">Anonymous</span>
                  </div>
                </div>
              </div>
            </If>
            <div style={{ padding: '10px 0px 0px 0px' }}>
              <If condition={size(enterpiseObjectives) > 0}>
                <Button
                  className="profile-modal-save-btn float-left weeklyWinBtn"
                  onClick={this.handleSubmitLinkAction}
                  disabled={!this.state.isEnterpiseObjectiveSelected}>
                  <span className="profile-modal-save-btn-txt">
                    Link<span className="ml10 flaticon-tick"></span>
                  </span>
                </Button>
              </If>
              <Button
                className="profile-modal-cancel-btn float-right weeklyWinBtn"
                onClick={this.closeActionsLinkModal}>
                <span className="profile-modal-cancel-btn-txt">Cancel</span>
              </Button>
            </div>
          </ModalBody>
        </Modal>
        <div style={{ display: this.getTableDisplay() }}>
          <div className={'row pl-4'}>
            <If condition={!searchActions}>
              <Col md={4} xs={5} className="action-table-add-action-container">
                {!this.props.hideAddActionButtons && (
                  <div>
                    {tableType !== 'subAction' ? (
                      <Button
                        color="primary"
                        className={'font-weight-bold addTaskBtn-p'}
                        onClick={() => this.handleShowWinsModal()}
                        style={{ height: '38px' }}>
                        {'Add action'}
                        <BiPlus style={{ marginBottom: '1px' }} />
                      </Button>
                    ) : this.props.isParentTaskPublic || orgAdmin ? (
                      <Button
                        color="primary"
                        className={'font-weight-bold addTaskBtn-p'}
                        onClick={() => this.handleShowWinsModal()}
                        style={{ height: '38px' }}>
                        {'Add subaction'}
                        <BiPlus style={{ marginBottom: '1px' }} />
                      </Button>
                    ) : (
                      <div>
                        {(this.isCreator(this.props.parentTaskObj) ||
                          this.isAssignee(this.props.parentTaskObj)) && (
                          <Button
                            color="primary"
                            className={'font-weight-bold addTaskBtn-p'}
                            onClick={() => this.handleShowWinsModal()}
                            style={{ height: '38px' }}>
                            {'Add subaction'}
                            <BiPlus style={{ marginBottom: '1px' }} />
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </Col>

              <Col md={4} className="text-right" xs={7}>
                {!this.props.hideAddActionButtons && tableType !== 'subAction' && (
                  <Button
                    onClick={this.toggleQuickActionsCollapse}
                    color="info"
                    className={'addSuggestedBtn-p'}>
                    Suggested actions <BiTask style={{ marginBottom: '1px' }} />
                  </Button>
                )}
              </Col>
            </If>

            {searchActions && (
              <Col md={9} xs={12}>
                <InputGroup style={{ height: '40px', width: '100%' }}>
                  <Input
                    className="toolkit-field tool-search-box"
                    placeholder="Search ..."
                    onChange={this.handleSearchQueryChanged}
                  />
                  <InputGroupAddon addonType="append">
                    <i
                      style={{ color: '#818389', padding: '7px' }}
                      className="flaticon-search"></i>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
            )}

            <Col
              md={searchActions && !exportActions ? 3 : 4}
              className={`mobile-filter-align ${isMobile ? 'mt-2' : ''}`}>
              {this.state.allTodosCopy.length && exportActions ? (
                <div style={{ marginRight: '6px' }}>
                  <div className="single_group_menu_events_export_btn">
                    <CSVLink
                      data={this.getData([...this.state.allTodosCopy])}
                      headers={actionsStaticHeaders}
                      filename={`Group Actions - ${moment().format(
                        'MM/DD/YYYY'
                      )}.csv`}
                      target="_blank">
                      Export Actions
                    </CSVLink>
                  </div>
                </div>
              ) : (
                ''
              )}
              <div className="dynamic-filter-div">
                {allTodosCopy.length >= 0 ? (
                  <ActionsFilterComponent
                    filterParams={filterParams}
                    updateFilterParams={this.props.updateFilterParams}
                  />
                ) : (
                  ''
                )}
              </div>
            </Col>
          </div>

          <Collapse
            isOpen={this.state.quickActionsCollapseOpen}
            className="bg-white">
            <div className="weekly-wins-inspirations">
              <div className="d-flex justify-content-between align-items-center">
                <div className="title">Actions You Can Take</div>
                <div
                  className="cursor-pointer px-4"
                  onClick={this.toggleQuickActionsCollapse}>
                  <BiXCircle size={'24px'} />
                </div>
              </div>

              <hr className="mt0 mb20 ml20 mr20" />
              <div>
                {this.populateInpirations()}
                <div
                  onClick={this.loadMoreInpirations}
                  className="action-btn"
                  style={{ float: 'left', marginLeft: '20px' }}>
                  {this.state.expanded ? 'See less' : 'See more'}
                  <i
                    className={(this.state.expanded
                      ? 'flaticon-up-arrow '
                      : 'flaticon-down-arrow'
                    ).concat(' review-mapping-row')}
                    style={{ marginLeft: '65px', marginTop: '-18px' }}></i>
                </div>
                <div
                  onClick={this.refreshInpirations}
                  className="action-btn"
                  style={{
                    float: 'right',
                    paddingRight: '20px',
                    marginBottom: '15px',
                  }}>
                  Refresh{' '}
                  <i
                    className="review-mapping-row flaticon-refresh"
                    style={{ marginLeft: '52px', marginTop: '-24px' }}></i>
                </div>
                <div className="clearfix"></div>
              </div>
            </div>
          </Collapse>

          {allTodos.length > 0 ? (
            <BottomScrollListener onBottom={this.handleOnDocumentBottom}>
              {(scrollRef) => (
                <div
                  className="action-table-scroll-wrapper my-4 action-table-height-custm"
                  ref={scrollRef}>
                  <span className="action-table-add-column-align">
                    {extra_col.length > 0 ? (
                      <Dropdown
                        className="actionColumnShown_add"
                        isOpen={dropdownOpenCol == 'addCol'}
                        toggle={() => this.toggleCol('addCol')}>
                        <DropdownToggle size="lg" className="ac-tb-add-col-btn">
                          <span
                            data-for={'add-col-btn-info'}
                            id="add-col-btn-info"
                            data-tip="Add a Column">
                            {' '}
                            +{' '}
                          </span>
                          <ReactTooltip id={'add-col-btn-info'} />
                        </DropdownToggle>
                        <DropdownMenu>
                          {extra_col.map((el) => {
                            return (
                              <DropdownItem
                                onClick={() => this.addColumnToTable(el)}
                                key={el}>
                                {action_table_column_name_display(el)}{' '}
                              </DropdownItem>
                            )
                          })}
                        </DropdownMenu>
                      </Dropdown>
                    ) : null}
                  </span>

                  <div
                    className={`actions-table-div ${
                      this.props.isModal ? 'action-modal-table-css' : ''
                    } p0 ${plainTable ? '' : 'bx-shadow-actions'}`}>
                    <LayoutRow
                      plainTable={plainTable}
                      className="mobileNoheightActionTable">
                      <Col
                        xs={
                          isMobile ? 5 : actionColumnShown.length === 3 ? 5 : 3
                        }
                        className="px-0">
                        <div style={{ height: '35px' }}>
                          <ActionLayoutHeading
                            plainTable={plainTable}
                            className="p-2 border border-grey"
                            colWidth={this.handleColWidth('actionTitle', false)}
                            fullWidth>
                            {this.renderDDtab('actionTitle')}
                          </ActionLayoutHeading>
                        </div>

                        {allTodos.length > 0 &&
                          actionColumnShown &&
                          allTodos.map((todo, i) => {
                            return (
                              <Row
                                className={'planning-row-mobile-height'}
                                key={`${todo._id}-${i}`}>
                                <ActionTitle
                                  parentActionId={parentActionId}
                                  tableType={tableType}
                                  isParentTaskPublic={isParentTaskPublic}
                                  handleSubActionUnlink={
                                    this.handleSubActionUnlink
                                  }
                                  noEdit={this.props.noEdit}
                                  todo={todo}
                                  viewEditTask={this.viewEditTask}
                                  currentUser={currentUser}
                                  getEOList={this.getEOList}
                                  unlinkEO={this.unlinkEO}
                                  handleUpdateInTable={this.handleUpdateInTable}
                                  handleDeleteTodo={this.handleDeleteTodo}
                                  handleUnDeleteTodo={this.handleUnDeleteTodo}
                                  titleCol={this.handleColWidth(
                                    'actionTitle',
                                    false
                                  )}
                                  titleColMobile={12}
                                  actionColumnShown={actionColumnShown}
                                  {...this.props}
                                  plainTable={plainTable}
                                />
                              </Row>
                            )
                          })}
                      </Col>

                      <Col
                        xs={
                          isMobile ? 7 : actionColumnShown.length === 3 ? 7 : 9
                        }
                        className="scrollable-action-table-row px-0">
                        <Row
                          className="row-scroll-width"
                          style={{
                            //width: `${totalColsCounter * 122}px`,
                            width: `100%`,
                            flexWrap: 'nowrap',
                          }}>
                          {actionColumnShown.map((e, idx) => {
                            return (
                              <ActionLayoutHeading
                                className="p-2 border border-grey"
                                colWidth={this.handleColWidth(e, isMobile)}
                                plainTable={plainTable}
                                key={e + '_' + idx}>
                                {this.renderDDtab(e)}
                              </ActionLayoutHeading>
                            )
                          })}
                        </Row>
                        {allTodos.length > 0 &&
                          actionColumnShown &&
                          allTodos.map((todo, i) => {
                            return (
                              <ActionRow
                                totalColsCounter={totalColsCounter}
                                parentActionId={parentActionId}
                                tableType={tableType}
                                isParentTaskPublic={isParentTaskPublic}
                                handleSubActionUnlink={
                                  this.handleSubActionUnlink
                                }
                                noEdit={this.props.noEdit}
                                todo={todo}
                                actionColumnShown={actionColumnShown}
                                viewEditTask={this.viewEditTask}
                                currentUser={currentUser}
                                getEOList={this.getEOList}
                                unlinkEO={this.unlinkEO}
                                handleUpdateInTable={this.handleUpdateInTable}
                                handleDeleteTodo={this.handleDeleteTodo}
                                handleUnDeleteTodo={this.handleUnDeleteTodo}
                                hideTitle
                                {...this.props}
                                plainTable={plainTable}
                                key={todo._id}
                              />
                            )
                          })}
                      </Col>
                    </LayoutRow>
                  </div>
                </div>
              )}
            </BottomScrollListener>
          ) : (
            this.props.placeholderComp || (
              <PlaceholderWins tableType={tableType} />
            )
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    sortParams: state.sortFilterParams.actions.sort,
    filterParams: state.sortFilterParams.actions.filter,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateSortParams: (data) =>
      dispatch(actionCreators.updateActionsSort(data)),
    updateFilterParams: (data) =>
      dispatch(actionCreators.updateActionsFilter(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionsTable)
